// tslint:disable
export enum AddressType {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description CORPORATE HEADQUARTERS
     */
    CORPORATEHEADQUARTERS = 1,
    /**
     * @description SALES OFFICE
     */
    SALESOFFICE = 2,
    /**
     * @description RESIDENTIAL ADDRESS
     */
    RESIDENTIALADDRESS = 3,
    /**
     * @description WORK ADDRESS
     */
    WORKADDRESS = 4,
    /**
     * @description SEASONAL ADDRESS
     */
    SEASONALADDRESS = 5,
    /**
     * @description MAILING ADDRESS
     */
    MAILINGADDRESS = 6,
    /**
     * @description BILLING ADDRESS
     */
    BILLINGADDRESS = 7,
    /**
     * @description SHIPPING ADDRESS
     */
    SHIPPINGADDRESS = 8,
}
